/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AmenitiesInputs */

const en_amenities = /** @type {(inputs: AmenitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amenities`)
};

const de_amenities = /** @type {(inputs: AmenitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstattung`)
};

/**
* | output |
* | --- |
* | "Amenities" |
*
* @param {AmenitiesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const amenities = /** @type {((inputs?: AmenitiesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AmenitiesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_amenities(inputs)
	return de_amenities(inputs)
});